import { UserResponseDto } from '@hello-hola/shared-schema';
import { create } from 'zustand';

export interface AuthStore {
  user?: UserResponseDto;
  token?: string;
  setUser: (user?: UserResponseDto) => void;
  setToken: (token?: string) => void;
  reset: () => void;
}

export const authStore = create<AuthStore>((set) => ({
  user: undefined,
  token: undefined,
  setUser: (user) => set({ user }),
  setToken: (token) => set({ token }),
  reset: () => set({ user: undefined, token: undefined }),
}));